/* eslint-disable */ 
import {useState } from "react";
import { Flex, Text, Icon, useColorModeValue, useToast, Link } from '@chakra-ui/react'; 
import { TbFileInvoice } from 'react-icons/tb';
import { NavLink  as RouterLink } from 'react-router-dom';

// Custom components   

import CommonDatatable from 'components/datatable/CommonDatatable';
import Actions from 'views/privado/servicesTracking/webTracking/components/Actions';

import service from 'services/webTrackingService';

import { 
  createColumnHelper
} from '@tanstack/react-table'
  
type RowObj = {
    exp_HouseString: number;
    exp_AduanaString: number;
    nom_Etapa: string;
    fecha: string;
    hora_Etapa: string;
    nom_Embarcador: string;
    doc_Transp: string;
    observacion: string;
    referencia: string;
    origen: string;
    destino: string;
    fechaUnida: string;
    ord_Etapa: string;
    fechaString: string;
};

import { EXPORT_TITLE, EXPORT_DESCRIPTION, PATH_PRIVADO, PATH_WEB_TRACKING_DETALLE } from "const/CommonConst";

export default function DataTable() {
	const textColor = useColorModeValue("navy.700", "white");

  const toast = useToast()

  const [tableData, setTableData] = useState([]);

  const [showEmptyState, setShowEmptyState] = useState(true);
  const [disabledActions, setDisabledActions] = useState(false);
  const [showProgressSearch, setShowProgressSearch] = useState(false);
  const [showProgressExport, setShowProgressExport] = useState(false);
  

  const fetchData = async (codigoConsignatario:string, embarque:string, oficina:string, expHouse:string, operacion:string, referencia:string, fechaI:string, fechaF:string) => {
    return await service.getTabla(codigoConsignatario, embarque, oficina, expHouse, operacion, referencia, fechaI, fechaF);
  };

  const onChangeFilters = async (selected:any) => {
	try {
	setShowEmptyState(false);
	setDisabledActions(true);
	setShowProgressSearch(true);
	setTableData(await fetchData(selected.cliente, selected.embarque, selected.oficina, selected.expediente, selected.operacion, selected.referencia, selected.fechaInicio, selected.fechaFin));
}
  finally{
	setDisabledActions(false);
	setShowProgressSearch(false);
  }
  };

  const onExportData = async (selected:any) => {
	try {
	setDisabledActions(true);
	setShowProgressExport(true);
	await service.getExcel(selected.cliente, selected.embarque, selected.oficina, selected.expediente, selected.operacion, selected.referencia, selected.fechaInicio, selected.fechaFin);
	toast({
		title: EXPORT_TITLE,
		description: EXPORT_DESCRIPTION,
		status: 'success',
		duration: 9000,
		isClosable: true,
	  });
}
  finally{
	setDisabledActions(false);
	setShowProgressExport(false);
  }
  };

    const columnHelper = createColumnHelper<RowObj>();
 	const columns = [
		columnHelper.accessor('exp_HouseString', {
			id: 'exp_HouseString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					EXPEDIENTE
				</Text>
			),
			cell: (info: any) => (				
				<Link as={RouterLink}  to={{pathname: `${PATH_PRIVADO}${PATH_WEB_TRACKING_DETALLE.replace(':id',info.getValue())}`, state: { id: info.getValue() }}}>
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text></Link>
			)
		}), 
		columnHelper.accessor('exp_AduanaString', {
			id: 'exp_AduanaString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					EXPEDIENTE ADUANA
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('origen', {
			id: 'origen',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					ORIGEN
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
          {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('destino', {
			id: 'destino',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					DESTINO
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			  </Text>
			)
		}),
		columnHelper.accessor('doc_Transp', {
			id: 'doc_Transp',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					DOCUMENTO TRANSPORTE
				</Text>
			),
			cell: (info) => (
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('referencia', {
			id: 'referencia',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        REFERENCIA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('nom_Embarcador', {
			id: 'nom_Embarcador',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        EMBARCADOR
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('fechaString', {
			id: 'fechaString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        FECHA ULTIMA ETAPA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('hora_Etapa', {
			id: 'hora_Etapa',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        HORA ULTIMA ETAPA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		})   ,
		columnHelper.accessor('nom_Etapa', {
			id: 'nom_Etapa',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        NOMBRE ULTIMA ETAPA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelper.accessor('observacion', {
			id: 'observacion',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        OBSERVACION
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) 
	];
	
  return ( 
    <CommonDatatable
    columnsDefinition={columns}
    tableData={tableData}	
	showEmptyState={showEmptyState}
	isLoading={disabledActions}
    actionContent={    
        <Actions onChange={onChangeFilters} 
				 onExport={onExportData}
				 disabledActions={disabledActions} 
				 showProgressExport={showProgressExport} 
				 showProgressSearch={showProgressSearch} /> }
      />        
  )
} 
